export default __webpack_public_path__ + "static/media/app.1e052c4d.svg";